import React, { useEffect, useRef, useState } from 'react'
import { Gantt} from "dhtmlx-gantt";
import "dhtmlx-gantt/codebase/dhtmlxgantt.css";
import "dhtmlx-gantt/codebase/skins/dhtmlxgantt_new_material.css";
import  { 
	gantLayout,
	setLightBoxSections,
	sectionForMilestones,
	sectionForProjects,
	configColumns,
	getGanttData,
	zoomConfig,
    getGanttDataResourcesForTraditional,
    getGanttDataResourcesForTraditional_available
} from "./helpersToGantt"
import { getData } from '../../data/data';
import { useTranslation } from "react-i18next";
import { Button, Container, Row } from 'react-bootstrap';

var demo_tasks = {
	"tasks":[
		{"id":11, "text":"Project #1", "start_date":"28-03-2023", "duration":"11", "progress": 0.6, "open": true},
		{"id":1, "text":"Project #2", "start_date":"01-04-2023", "duration":"18", "progress": 0.4, "open": true},

		{"id":2, "text":"Task #1", "start_date":"02-04-2023", "duration":"8", "parent":"1", "progress":0.5, "open": true},
		{"id":3, "text":"Task #2", "start_date":"11-04-2023", "duration":"8", "parent":"1", "progress": 0.6, "open": true},
		{"id":4, "text":"Task #3", "start_date":"13-04-2023", "duration":"6", "parent":"1", "progress": 0.5, "open": true},
		{"id":5, "text":"Task #1.1", "start_date":"02-04-2023", "duration":"7", "parent":"2", "progress": 0.6, "open": true},
		{"id":6, "text":"Task #1.2", "start_date":"03-04-2023", "duration":"7", "parent":"2", "progress": 0.6, "open": true},
		{"id":7, "text":"Task #2.1", "start_date":"11-04-2023", "duration":"8", "parent":"3", "progress": 0.6, "open": true},
		{"id":8, "text":"Task #3.1", "start_date":"14-04-2023", "duration":"5", "parent":"4", "progress": 0.5, "open": true},
		{"id":9, "text":"Task #3.2", "start_date":"14-04-2023", "duration":"4", "parent":"4", "progress": 0.5, "open": true},
		{"id":10, "text":"Task #3.3", "start_date":"14-04-2023", "duration":"3", "parent":"4", "progress": 0.5, "open": true},
		
		{"id":12, "text":"Task #1", "start_date":"03-04-2023", "duration":"5", "parent":"11", "progress": 1, "open": true},
		{"id":13, "text":"Task #2", "start_date":"02-04-2023", "duration":"7", "parent":"11", "progress": 0.5, "open": true},
		{"id":14, "text":"Task #3", "start_date":"02-04-2023", "duration":"6", "parent":"11", "progress": 0.8, "open": true},
		{"id":15, "text":"Task #4", "start_date":"02-04-2023", "duration":"5", "parent":"11", "progress": 0.2, "open": true},
		{"id":16, "text":"Task #5", "start_date":"02-04-2023", "duration":"7", "parent":"11", "progress": 0, "open": true},

		{"id":17, "text":"Task #2.1", "start_date":"03-04-2023", "duration":"2", "parent":"13", "progress": 1, "open": true},
		{"id":18, "text":"Task #2.2", "start_date":"06-04-2023", "duration":"3", "parent":"13", "progress": 0.8, "open": true},
		{"id":19, "text":"Task #2.3", "start_date":"10-04-2023", "duration":"4", "parent":"13", "progress": 0.2, "open": true},
		{"id":20, "text":"Task #2.4", "start_date":"10-04-2023", "duration":"4", "parent":"13", "progress": 0, "open": true},
		{"id":21, "text":"Task #4.1", "start_date":"03-04-2023", "duration":"4", "parent":"15", "progress": 0.5, "open": true},
		{"id":22, "text":"Task #4.2", "start_date":"03-04-2023", "duration":"4", "parent":"15", "progress": 0.1, "open": true},
		{"id":23, "text":"Task #4.3", "start_date":"03-04-2023", "duration":"5", "parent":"15", "progress": 0, "open": true},
		{"id":24, "text":"Task #4.2", "start_date":"03-04-2023", "duration":"4", "parent":"15", "progress": 0.1, "open": true},
		{"id":25, "text":"Task #4.3", "start_date":"03-04-2023", "duration":"5", "parent":"15", "progress": 0, "open": true},
		{"id":26, "text":"Task #4.2", "start_date":"03-04-2023", "duration":"4", "parent":"15", "progress": 0.1, "open": true},
		{"id":27, "text":"Task #4.3", "start_date":"03-04-2023", "duration":"5", "parent":"15", "progress": 0, "open": true}
		
	],
	"links":[
		{"id":"1","source":"1","target":"2","type":"1"},
		{"id":"2","source":"2","target":"3","type":"0"},
		{"id":"3","source":"3","target":"4","type":"0"},
		{"id":"4","source":"2","target":"5","type":"2"},
		{"id":"5","source":"2","target":"6","type":"2"},
		{"id":"6","source":"3","target":"7","type":"2"},
		{"id":"7","source":"4","target":"8","type":"2"},
		{"id":"8","source":"4","target":"9","type":"2"},
		{"id":"9","source":"4","target":"10","type":"2"},
		{"id":"10","source":"11","target":"12","type":"1"},
		{"id":"11","source":"11","target":"13","type":"1"},
		{"id":"12","source":"11","target":"14","type":"1"},
		{"id":"13","source":"11","target":"15","type":"1"},
		{"id":"14","source":"11","target":"16","type":"1"},
		{"id":"15","source":"13","target":"17","type":"1"},
		{"id":"16","source":"17","target":"18","type":"0"},
		{"id":"17","source":"18","target":"19","type":"0"},
		{"id":"18","source":"19","target":"20","type":"0"},
		{"id":"19","source":"15","target":"21","type":"2"},
		{"id":"20","source":"15","target":"22","type":"2"},
		{"id":"21","source":"15","target":"23","type":"2"}
	]
};



const GanttForView = ({uid, available, data , totalHours,setTotalEffort}) => {
    const [ganttInstance ,setGanttInstance] = useState("")
    const [t, i18n] = useTranslation("schedule");
    const [rol ,setRol] = useState("")
    const [user_lg, setUser_lg] = useState("")

    let container = useRef();
    useEffect(() => {
        // instanciando la clase Gantt
        const gantt = Gantt.getGanttInstance();
        setGanttInstance(gantt)
        // obteniendo rol usuario
        setRol(window.localStorage.getItem("rol"));
        setUser_lg(window.localStorage.getItem("idioma"));
        //configuracion de layout (grid and tasklist)
         gantt.config.layout = gantLayout
       /* gantt.config.layout = {
         css: "gantt_container",
         rows: [
           {
             cols: [
               { view: "grid", group: "grids", scrollY: "scrollVer" },
               { resizer: true, width: 1 },
               { view: "timeline", scrollX: "scrollHor", scrollY: "scrollVer" },
               { view: "scrollbar", id: "scrollVer", group: "vertical" }
             ],
             gravity: 2
           },
           { resizer: true, width: 1 },
           {
             config: {
               // configuration of the columns for the Resource Grid,
               // this configuration is later used in the Layout configuration
               columns: [
                 {
                   name: "name", label: "Name", tree: true, resize: true, template: function (resource) {
                     return resource.text;
                   }
                 },
                 {
                   name: "workload", label: "Workload", template: function (resource) {
                     var totalDuration = 0;
                     if (resource.$role === "task") {
                       gantt.getResourceAssignments(resource.$resource_id, resource.$task_id).forEach(function (a) {
                         totalDuration += a.value * a.duration;
                       });
                     } else {
                       gantt.ext.resources.getSummaryResourceAssignments(resource.id).forEach(function (assignment) {
                         totalDuration += Number(assignment.value) * assignment.duration;
                       });
                     }
                     return (totalDuration || 0) + "h";
                   }
                 }
               ]
             },
             cols: [
               { view: "resourceGrid", group: "grids", width: 435, scrollY: "resourceVScroll" },
               { resizer: true, width: 1 },
               { view: "resourceTimeline", scrollX: "scrollHor", scrollY: "resourceVScroll" },
               { view: "scrollbar", id: "resourceVScroll", group: "vertical" }
             ],
             gravity: 1
           },
           { view: "scrollbar", id: "scrollHor" }
         ]
       } */
        //configurando secciones del modal segun el type
        setLightBoxSections(gantt,t);
        sectionForMilestones(gantt)
        sectionForProjects(gantt)
        // configuracion de plugins 
        gantt.plugins({
            auto_scheduling: true,
            click_drag: true,
            critical_path: true,
            drag_timeline: true,
            fullscreen: true,
            grouping: true,
            keyboard_navigation: true,
            marker: true,
            multiselect: true,
            overlay: true,
            quick_info: false,
            tooltip: true,
            undo: true,
            export_api: true,
          });
        // asignando el codigo del proyecto
        gantt.serverList("projectId", [uid]);
        
        // configuraciones adicionales 

        gantt.config.order_branch = false; //permite reordenar verticalmente las tareas dentro del mismo nivel de arbol
        gantt.config.bar_height = 25; // altura de las barras en el grid
        gantt.config.row_height = 40; // altura de las filas
        gantt.config.show_progress = true; // visualizar el progreso dentro de las barras de tareas
        gantt.config.resource_property = "owner_id";	// define la propiedad del objeto que almacena el id del recurso asociado con la tarea
        gantt.config.order_branch_free = false; // permite reordenar tareas dentro de todo el gantt
        gantt.config.drag_progress = true; // permite la posibilidad de cambiar el progreso desde el grid
        gantt.i18n.setLocale(user_lg); // usar el idioma para el gantt 
        /* gantt.config.autosize = false; */ // ojo
        gantt.config.auto_types = false; // cambia de tipo de forma automatica 
        gantt.config.keyboard_navigation_cells = true; // permite navegar con el teclado
        gantt.config.reorder_grid_columns = true; // permite reordenar las columnas
        gantt.config.smart_rendering =true // renderizar de manera inteligente
        gantt.config.show_task_cells  = true // habilita o desabilidad la visualizacion de los bordes 
        /* gantt.ext.fullscreen.getFullscreenElement = () => {
          return document.getElementById("show-btns-gantt");
        }; */

        //traer data y cargarla
        //getGanttData(uid,gantt)
        if(available){
            getGanttDataResourcesForTraditional_available(data,gantt)
        }else{
            getGanttDataResourcesForTraditional(uid,gantt ,setTotalEffort)
        }

        //texto lateral barras
        /* gantt.templates.rightside_text = function (start, end, task) {
            return getResourceNames(gantt.serverList("resourceList"), task.owner_id);
        } */ 
          
    // Permitir reordenar verticamente dentro del mismo nivel
    /*   gantt.config.order_branch = "marker"; */
    /*  gantt.config.drag_progress = false; */
        //iniciando gantt
        gantt.templates.resource_cell_value = function (start_date, end_date, resource, tasks) {
            let result = 0;
            tasks.forEach(function (item) {
                const assignments = gantt.getResourceAssignments(resource.id, item.id);
                assignments.forEach(function (assignment) {
                    const task = gantt.getTask(assignment.task_id);
                    result += assignment.value * 1;
                });
            });
    
            if (result % 1) {
                result = Math.round(result * 10) / 10;
            }
            return "<div>" + result + "</div>";
        };

    const confiColumnsSTD = [  
        {
            name: "text",
            label: t("schedule_gantt_activity"),
            tree: true,
            min_width: 150,
            width: "*",
            resize: true,
            hide: false,
            /* editor: textEditorColum, */
            template: (item) => {
            let normalText = `<b>${item.text}</b>`;
            if (item.type == "project") {
                return normalText;
            } else {
                return item.text;
            }
            },
        },
        {
            name: "start_date",
            label: t("schedule_gantt_start"),
            align: "center",
            min_width: 85,
            resize: true,
           /*  editor: start_dateEditor, */
            hide: false,
            template: (item) => {
            let dateWithFormat = new Intl.DateTimeFormat("es-CL").format(
                item.start_date
            );
            return dateWithFormat;
            },
        },
        {
            name: "end_date",
            label: t("schedule_gantt_end"),
            align: "center",
            min_width: 85,
            resize: true,
         /*    editor: end_dateEditor, */
            hide: false,
            template: (item) => {
            let dateWithFormat = new Intl.DateTimeFormat("es-CL").format(
                item.end_date
            );
            return dateWithFormat;
            },
        },
/*                 {
            name: "dayDuration",
            label: "Duración(d)",
            resize: true,
            align: "center",
            editor: dayDurationEditor,
            with: 110,
            hide: showDuration,
            template: (task) => {
            return dayFormatter.format(task.duration);
            },
        }, */
        /*    {
            name: "hourDuration",
            label: "Duración(hrs)",
            resize: true,
            align: "center",
            editor: hourDurationEditor,
            with: 50,
            hide: false,
            template: (task) => {
            return hourFormatter.format(task.duration);
            },
        }, */
        {
            name: "plannedHours" ,
            label: "Plan. Hrs",
            min_width: 80,
            align: "center",
            hide: false,
            template: function (item) {
            return item.plannedHours || 0;
            },
        },
        {
            name: "realHours",
            label: "Real. Hrs" ,
            min_width: 80,
            align: "center",
            hide: false,
            template: function (item) {

            return item.realHours || 0;
            },
        },
        {
            name: "executedHours",
            label: "Ejec. Hrs" ,
            min_width: 80,
            align: "center",
            hide: true,
            template: function (item) {

            return item.executeHours || 0;
            },
        },
        {
            name: "participacion",
            label: "% Asignación" ,
            min_width: 80,
            align: "center",
            hide: available? false : true,
            template: function (item) {
                if(item.type != 'project') {
                    return  `${(((item.plannedHours / totalHours)* 100)).toFixed(2) } %` 
                }
           
            },
        },
        //aqui 
        {
            name: "progress",
            label: t("schedule_gantt_progress"),
            min_width: 80,
            align: "center",
            hide: true,
            template: function (item) {
        
            return Math.round(item.progress) + "%";
            },
        },
        {
            name: "planned",
            label: " % Plan.",
            min_width: 90,
            align: "center",
            hide: true,
            template: function (item) {
            if (item.planned) {
                return `${item.planned}%`;
            } else {
                return 0;
            }
            },
        },
        {
            name: "indicator",
            label: "Indica.",
            min_width: 110,
            align: "center",
            hide: true,
        /*     template: function (item) {
            if (item.type != "project") {
                const iconCritical =
                "<i class='fa fa-exclamation-circle text-danger'></i>";
                const iconCriticalExt =
                "<i class='fa fa-exclamation-circle text-dark'></i>";
                const iconModerate =
                "<i class='fa fa-exclamation-circle text-warning'></i>";
                const iconOntime = "<i class='fa fa-check-circle text-success'></i>";
                const selectState = (indicator) => {
                if (indicator == 1) {
                    return iconOntime;
                } else if (indicator == 2) {
                    return iconModerate;
                } else if (indicator == 3) {
                    return iconCritical;
                } else {
                    return iconCriticalExt;
                }
                };
                const state = selectState(item.indicator);
                const valueOfIndi = byId(
                gantt.serverList("indicator"),
                item.indicator
                );
                const textOfIndi = `<div class="text-center w-100">${state}<b class="ml-1">${valueOfIndi}</b></div>`;
                return textOfIndi;
            } else {
                return;
            }
            }, */
        },
        ];

   /*  const confiColumnsSTD_Resources = [
		{ name: "text", tree: true, width: 200, resize: true },
		{ name: "start_date", align: "center", width: 100, resize: true },
		{
			name: "owner", align: "center", width: 75, label: "Owner", template: function (task) {
				if (task.type == gantt.config.types.project) {
					return "";
				}
				const resources = gantt.getTaskResources(task.id);
				if (!resources.length) {
					return "Unassigned";
				} else if (resources.length === 1) {
					return resources[0].text;
				} else {
					return resources.map(function (resource) {
						return "<div class='owner-label' title='" + resource.text + "'>" + resource.text.substr(0, 1) + "</div>";
					}).join("");
				}
			}, resize: true
		},
		{ name: "duration", width: 60, align: "center", resize: true },
		{ name: "add", width: 44 }
	] */
    gantt.config.columns = confiColumnsSTD;
    //gantt.config.columns = confiColumnsSTD_Resources  
    zoomConfig(gantt)
    gantt.ext.zoom.setLevel("quarter");
    gantt.init(container.current);
    gantt.config.readonly= true
    gantt.config.resources = true;
	gantt.config.resource_store = "resource";
	gantt.config.resource_property = "owner";
	gantt.config.order_branch = true;
	gantt.config.open_tree_initially = true;
 
    /* gantt.batchUpdate(()=>{
        gantt.parse({
            "tasks":[
                {"id":11, "text":"Project #1", "start_date":"28-03-2023", "duration":"11", "progress": 0.6, "open": true},
                {"id":1, "text":"Project #2", "start_date":"01-04-2023", "duration":"18", "progress": 0.4, "open": true},
        
                {"id":2, "text":"Task #1", "start_date":"02-04-2023", "duration":"8", "parent":"1", "progress":0.5, "open": true},
                {"id":3, "text":"Task #2", "start_date":"11-04-2023", "duration":"8", "parent":"1", "progress": 0.6, "open": true},
                {"id":4, "text":"Task #3", "start_date":"13-04-2023", "duration":"6", "parent":"1", "progress": 0.5, "open": true},
                {"id":5, "text":"Task #1.1", "start_date":"02-04-2023", "duration":"7", "parent":"2", "progress": 0.6, "open": true},
                {"id":6, "text":"Task #1.2", "start_date":"03-04-2023", "duration":"7", "parent":"2", "progress": 0.6, "open": true},
                {"id":7, "text":"Task #2.1", "start_date":"11-04-2023", "duration":"8", "parent":"3", "progress": 0.6, "open": true},
                {"id":8, "text":"Task #3.1", "start_date":"14-04-2023", "duration":"5", "parent":"4", "progress": 0.5, "open": true},
                {"id":9, "text":"Task #3.2", "start_date":"14-04-2023", "duration":"4", "parent":"4", "progress": 0.5, "open": true},
                {"id":10, "text":"Task #3.3", "start_date":"14-04-2023", "duration":"3", "parent":"4", "progress": 0.5, "open": true},
                
                {"id":12, "text":"Task #1", "start_date":"03-04-2023", "duration":"5", "parent":"11", "progress": 1, "open": true},
                {"id":13, "text":"Task #2", "start_date":"02-04-2023", "duration":"7", "parent":"11", "progress": 0.5, "open": true},
                {"id":14, "text":"Task #3", "start_date":"02-04-2023", "duration":"6", "parent":"11", "progress": 0.8, "open": true},
                {"id":15, "text":"Task #4", "start_date":"02-04-2023", "duration":"5", "parent":"11", "progress": 0.2, "open": true},
                {"id":16, "text":"Task #5", "start_date":"02-04-2023", "duration":"7", "parent":"11", "progress": 0, "open": true},
        
                {"id":17, "text":"Task #2.1", "start_date":"03-04-2023", "duration":"2", "parent":"13", "progress": 1, "open": true},
                {"id":18, "text":"Task #2.2", "start_date":"06-04-2023", "duration":"3", "parent":"13", "progress": 0.8, "open": true},
                {"id":19, "text":"Task #2.3", "start_date":"10-04-2023", "duration":"4", "parent":"13", "progress": 0.2, "open": true},
                {"id":20, "text":"Task #2.4", "start_date":"10-04-2023", "duration":"4", "parent":"13", "progress": 0, "open": true},
                {"id":21, "text":"Task #4.1", "start_date":"03-04-2023", "duration":"4", "parent":"15", "progress": 0.5, "open": true},
                {"id":22, "text":"Task #4.2", "start_date":"03-04-2023", "duration":"4", "parent":"15", "progress": 0.1, "open": true},
                {"id":23, "text":"Task #4.3", "start_date":"03-04-2023", "duration":"5", "parent":"15", "progress": 0, "open": true},
                {"id":24, "text":"Task #4.2", "start_date":"03-04-2023", "duration":"4", "parent":"15", "progress": 0.1, "open": true},
                {"id":25, "text":"Task #4.3", "start_date":"03-04-2023", "duration":"5", "parent":"15", "progress": 0, "open": true},
                {"id":26, "text":"Task #4.2", "start_date":"03-04-2023", "duration":"4", "parent":"15", "progress": 0.1, "open": true},
                {"id":27, "text":"Task #4.3", "start_date":"03-04-2023", "duration":"5", "parent":"15", "progress": 0, "open": true}
                
            ]});
    }) */
        return () => {
          gantt.destructor();
          /* container.current.innerHTML = ""; */
        };
    }, [data]);

// panel btns 

    const expandAllTask = () => {
        ganttInstance.batchUpdate(function () {
        ganttInstance.eachTask(function (task) {
            ganttInstance.open(task.id);
        });
        });
    };

    const collapseAllTask = () => {
        ganttInstance.batchUpdate(function () {
        ganttInstance.eachTask(function (task) {
            ganttInstance.close(task.id);
        });
        });
    };
    const zoomIn = () => {
        ganttInstance.ext.zoom.zoomIn();
    };

    const zoomOut = () => {
        ganttInstance.ext.zoom.zoomOut();
    };

    return (
      <>
      <Container>
        <Button           
            variant="outline-grey"
            size="sm"
            onClick={collapseAllTask}
            title={t("schedule_gantt_collapse")}
        >
            <i className="fa fa-angle-double-up"></i>
        </Button>
        <Button
            variant="outline-grey"
            size="sm"
            onClick={expandAllTask}
            title={t("schedule_gantt_expand")}
        >
        <i className="fa fa-angle-double-down"></i>
        </Button>
        <Button
            variant="outline-grey"
            size="sm"
            onClick={zoomIn}
        > Zoom <i className="fa fa-plus"></i>
        </Button>
        <Button
            variant="outline-grey"
            size="sm"
            onClick={zoomOut}
        >Zoom <i className="fa fa-minus"></i>
        </Button>
    </Container>  
      <div ref={container} style={{width: "100%", minHeight: "200px", height:"350px", maxHeight:"400px" }}></div>
      
      </>
  )
}

export default GanttForView